export default __webpack_public_path__ + "4d94a5a38b57c772fe4c0d658cede39a.png";